// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.payment.StopPaymentByLandlordWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { StopPaymentByLandlordWebApiRequestDto } from '../..';

export const StopPaymentByLandlordWebApiHandler_stopPaymentByLandlord_Path =
  '/api/web/v1/payment/stopPaymentByLandlord';

/**
 * Stop payment by landlord
 */
export const StopPaymentByLandlordWebApiHandler_stopPaymentByLandlord = (
  postData: StopPaymentByLandlordWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, StopPaymentByLandlordWebApiRequestDto, void>(
    {
      endpoint: StopPaymentByLandlordWebApiHandler_stopPaymentByLandlord_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
